import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';
import { MOBILE_PAGE_CONFIG } from './pageConfig/daily/mobilePageConfig';
import { CASUAL_PAGE_CONFIG } from './pageConfig/daily/casualPageConfig';
import { PC_PAGE_CONFIG } from './pageConfig/daily/pcPageConfig';

const reqParams = '/overview/daily';
const Daily = () => {
  const dataFrame = useSelector(
    (state: any) => state?.dashboard?.currentGame?.data_frame,
    shallowEqual,
  );
  const pageMap: any = {
    mobile: MOBILE_PAGE_CONFIG,
    pc: PC_PAGE_CONFIG,
    casual: CASUAL_PAGE_CONFIG
  };
  return (
    <>
      <CommonPageRender
        reqParams={reqParams}
        pageConfigInit={pageMap?.[dataFrame]}
      />
    </>
  );
};

export default Daily;
